import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { ThemedButton } from '@helpcenter/themed-button';
import type { Appearance } from '@atlaskit/button';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { token } from '@atlaskit/tokens';
interface BackButtonProps {
	children: string;
	onClick: () => void;
	actionSubjectId: string;
	appearance?: Appearance;
}

const ThemedBackButton = (props: BackButtonProps) => {
	const { children, onClick, actionSubjectId, appearance } = props;

	return (
		<BackButtonWrapper>
			<ThemedButton
				iconBefore={
					// Icon is decorative — adjacent button text already conveys the label
					<ArrowLeftIcon spacing="spacious" label="" />
				}
				appearance={appearance}
				spacing="compact"
				actionSubjectId={actionSubjectId}
				onClick={onClick}
			>
				{children}
			</ThemedButton>
		</BackButtonWrapper>
	);
};

export default ThemedBackButton;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const BackButtonWrapper = styled.span`
	margin-left: ${token('space.negative.200', '-16px')};
`;
